module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc23-425d239f0e56639116201b79e760b747.jpg";